<template>
  <v-container py-0>
    <v-timeline dense>
      
      <v-timeline-item class="mt-2" hide-dot>
        <span>Upcoming</span>
      </v-timeline-item>

      <template v-if="futureEvents.length > 1">
        <v-timeline-item small v-for="event, index in futureEvents" :key="event.id">
          <v-layout>
            <v-flex xs4>
              <strong>{{event.date}}{{event.startTime ? ' @ '+formatTime(event.startTime) : ''}}</strong>
            </v-flex>

            <v-flex>
              <strong>{{event.name}}</strong>
              <div class="caption">{{event.address}}</div>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </template>

      <template v-else>
        <v-timeline-item small>
          <v-layout>
            <v-flex xs4>
              <strong>No Upcoming Events</strong>
              <div class="caption">Add an event to get started!</div>
            </v-flex>
            <v-flex>
              <span></span>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item hide-dot>
          <v-btn class="mx-0" color="primary" to="/event">
            Create Event
          </v-btn>
        </v-timeline-item>
      </template>

      <v-timeline-item hide-dot>
        <span>Invitations</span>
      </v-timeline-item>
      <v-timeline-item small color="accent">
        <v-layout>
          <v-flex xs4>
            <strong>No Pending Events</strong>
            <div class="caption">Ask someone to invite you to get started!</div>
          </v-flex>
          <v-flex>
            <span></span>
          </v-flex>
        </v-layout>
      </v-timeline-item>

      <v-timeline-item class="mt-2" hide-dot>
        <span>Past</span>
      </v-timeline-item>
      <template v-if="pastEvents.length > 0">
        <v-timeline-item small v-for="event, index in pastEvents" :key="index" color="secondary">
          <v-layout>
            <v-flex xs4>
              <strong>{{event.date}}{{event.startTime ? ' @ '+formatTime(event.startTime) : ''}}</strong>
            </v-flex>

            <v-flex>
              <strong>{{event.name}}</strong>
              <div class="caption">{{event.address}}</div>
            </v-flex>

          </v-layout>
        </v-timeline-item>
      </template>

      <template v-else>
        <v-timeline-item small color="secondary">
          <v-layout>
            <v-flex xs4>
              <strong>No Past Events</strong>
              <div class="caption">It looks like you're all caught up!</div>
            </v-flex>
            <v-flex>
              <span></span>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </template>

    </v-timeline>

  </v-container>
</template>
<script>

  import {mapGetters} from 'vuex'

  export default { 
    data(){
      return {
        
      }
    }, 
    computed: {
      ...mapGetters({
        pastEvents: 'events/getPastEvents',
        futureEvents: 'events/getFutureEvents'
      })
    }, 
    methods: {
      formatTime(time){
        let fTime = time.split(":");

        let hours = fTime[0] % 12 == 0 ? '12' : (fTime[0] % 12).toString();
        let mins = fTime[1].toString();
        let ampm = fTime[0] >= 12 ? 'PM' : 'AM';

        return `${hours}:${mins} ${ampm}`;
      }
    }, 
    mounted(){
      console.log(this.futureEvents.length);
    }
  }
  
</script>
<style>
</style>